(() => {
  const nativeControls = [
    'button',
    'input',
    'textarea',
    'select',
    'option',
    'summary',
    '[contenteditable="true"]',
    '[role="button"]',
    'xo-carousel-prev',
    'xo-carousel-next',
    'xo-carousel-pagination',
    'xo-carousel-pagination-bullet-active'
  ].join(',');

  const mediaControls = [
    'img',
    'picture',
    'svg',
    'video',
    'canvas',
    'model-viewer',
    'xo-360-viewer',
    'xo-360-viewer-content',
    'xo-product-media',
    '.xo-media'
  ].join(',');

  const textTargets = [
    'a',
    'p',
    'span',
    'strong',
    'em',
    'small',
    'label',
    'li',
    'td',
    'th',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    '.xo-price',
    '.xo-content',
    '.product-description',
    '.blog-v2__title',
    '.blog-v2__item-title',
    '.blog-v2__description',
    '.blog-v2__tag'
  ].join(',');

  let textSelectionIntent = false;

  const hasSelectableText = (element) => {
    const text = element.textContent || '';
    return text.trim().length > 0;
  };

  const shouldProtectTextSelection = (target) => {
    if (!(target instanceof Element)) return false;
    if (target.closest(nativeControls)) return false;
    if (target.closest(mediaControls)) return false;

    const textElement = target.closest(textTargets);
    if (textElement && hasSelectableText(textElement)) return true;

    return hasSelectableText(target) && !target.children.length;
  };

  const originalPreventDefault = Event.prototype.preventDefault;

  Event.prototype.preventDefault = function preventDefaultPatch() {
    const event = this;
    const type = event.type;

    if (
      textSelectionIntent &&
      (type === 'mousedown' || type === 'mousemove' || type === 'mouseup' || type === 'selectstart' || type === 'copy') &&
      shouldProtectTextSelection(event.target)
    ) {
      return;
    }

    return originalPreventDefault.call(event);
  };

  document.addEventListener('mousedown', (event) => {
    textSelectionIntent = event.button === 0 && shouldProtectTextSelection(event.target);

    if (!textSelectionIntent) return;
    event.stopPropagation();
  }, true);

  document.addEventListener('mousemove', (event) => {
    if (!textSelectionIntent || !shouldProtectTextSelection(event.target)) return;
    event.stopPropagation();
  }, true);

  document.addEventListener('selectstart', (event) => {
    if (!shouldProtectTextSelection(event.target)) return;
    textSelectionIntent = true;
    event.stopPropagation();
  }, true);

  document.addEventListener('copy', (event) => {
    if (!shouldProtectTextSelection(event.target)) return;
    event.stopPropagation();
  }, true);

  document.addEventListener('mouseup', () => {
    window.setTimeout(() => {
      textSelectionIntent = false;
    }, 0);
  }, true);
})();